import React from 'react';
import FailurePage from './FailurePage.jsx';

class AppErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, recoveryKey: 0 };
    }

    static getDerivedStateFromError() {
        return { hasError: true };
    }

    componentDidUpdate(prevProps) {
        if (this.state.hasError && prevProps.resetKey !== this.props.resetKey) {
            this.setState({ hasError: false });
        }
    }

    componentDidCatch(error, errorInfo) {
        console.error('AppErrorBoundary caught an error:', error, errorInfo);
    };

    handleRetry = () => {
        this.setState((prev) => ({ hasError: false, recoveryKey: prev.recoveryKey + 1 }));
    };

    render() {
        if (this.state.hasError) {
            return (
                <FailurePage
                    title="Oops, something broke"
                    message="The page hit an unexpected error. Please try again."
                    actionLabel="Retry"
                    onAction={this.handleRetry}
                />
            );
        }

        return <React.Fragment key={this.state.recoveryKey}>{this.props.children}</React.Fragment>;
    }
}

export default AppErrorBoundary;
